import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfDocjson } from '@/modules/Configuracion/interfaces'

export class DocJsonComunService extends BaseService<IConfDocjson> {
  constructor () {
    super({ baseUrl: 'system/docjson-comun/' })
  }
}
